/**
 * Tipografía del markdown de una respuesta del agente — la MISMA en sus dos
 * formas (#1116-A).
 *
 * Una respuesta se pinta con dos componentes distintos a lo largo de su vida:
 * `ChatMessages` mientras llega token a token (burbuja viva) y `MessageBubble`
 * una vez persistida. Al terminar el turno uno se desmonta y el otro se monta en
 * su sitio, así que **cualquier diferencia tipográfica entre ellos se ve como un
 * salto**: con `0.9rem` en la viva y `1rem` en la persistida, las 400 respuestas
 * de PROD medidas en #1116 cambiaban de altura al terminar (p50 +7,6 px, p95
 * +349 px, extremo +1.568 px).
 *
 * Vive en una constante y no en dos literales «que hay que acordarse de mover
 * juntos» porque eso último ya se probó y es como se llegó aquí: nada en el
 * código conectaba los dos valores, y nada avisaba al cambiar uno.
 *
 * ⚠️ No es un token de tema: `theme.chat.*` es para color (WCAG AA), y esto es
 * métrica de texto. Si algún día hace falta que el usuario la ajuste, entonces sí
 * tocará subirla al tema — y seguirá habiendo un solo sitio que cambiar.
 */
export const CHAT_MARKDOWN_TYPOGRAPHY = Object.freeze({
  fontSize: { xs: '0.875rem', md: '1rem' },
  lineHeight: 1.6,
});
